import axios from 'axios';

export function getLocationReference(id) {
    const url = `/api/location/${id}`;
    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then((response) => {
                const data = response.data.data;
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getAllLocationsByDistanceFromCoordinates(lat, long) {
    const url = `/api/location/`;
    return new Promise((resolve, reject) => {
        axios
            .get(url, { params: { latitude: lat, longitude: long } })
            .then((response) => {
                const data = response.data.data;
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getAllLocationsByDistance(starting_location_id) {
    const url = `/api/location/sucursal/${starting_location_id}`;
    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then((response) => {
                const data = response.data.data;
                resolve(data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getAllLocations() {
    const url = `/api/location`;
    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getLocationByCode(code) {
    const url = `/api/location/office/${code}`;
    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function getAllOffice() {
    const url = `/api/location/office`;
    return new Promise((resolve, reject) => {
        axios
            .get(url)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

export function putOfficeKey(data) {
    const url = `/api/location/putOffice`;
    return new Promise((resolve, reject) => {
        axios
            .put(url,data)
            .then((response) => {
                resolve(response.data.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
